import React from 'react'
import { NavUser } from '../index'

export default function Navbar(): React.ReactElement {
    return (
        <div className="navbar">
            <NavUser />
        </div>
    )
}
